import { Injectable } from '@angular/core';
import { HttpRequest, HttpResponse } from '@angular/common/http';
import { LoggingMessageService } from './logging-message.service';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { SessionStorageService } from './session-storage.service';
import { SubscriptionChangeService } from './subscription-change.service';


@Injectable({
  providedIn: 'root'
})
export class PendoService {

  private isPendoInitialized = false;
  private user: string;

  constructor(private authService: AuthService,  private storageService: SessionStorageService, private logger: LoggingMessageService,    
    private subscriptionService: SubscriptionChangeService) {
    // this.logger.debug('', 'CacheService', 'Creating new Cache');
  }

  public checkPendo(w: any) {
    this.user = this.authService.getTokenEmail();
    if (this.user && !this.isPendoInitialized) {
        this.logger.debug('pendo.service', 'checkPendo', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  'initialized', '');
        if (w && w.pendo && w.pendo.getVisitorId) {
            this.logger.debug('pendo.service', 'checkPendo', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  'Pendo is installed', '');
            const visitor = w.pendo.getVisitorId();
            this.logger.debug('pendo.service', 'checkPendo', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  `Visitor: ${visitor}`, '');
            this.initializePendo(w);
        }
    }
  }

  private initializePendo(w: any) {
    this.logger.debug('pendo.service', 'initializePendo', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, 'initializing', '');

    if (w.pendo && w.pendo.initialize) {
      const visitor = this.storageService.getPendoUserId();
      this.logger.info('pendo.service', 'initializePendo', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `Window:${w.name}, Visitor:${visitor}`, '');

      w.pendo.initialize({
          visitor: {
              id: visitor   // Required if user is logged in
          },
          account: {
              id: ''
          }
      });

      this.isPendoInitialized = true;
    }
  }

  public updatePendo(w: any) {
      this.logger.debug('pendo.service', 'updatePendo', this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString,  'updating pendo', '');
      // let visitor = this.user;
      let visitor = this.storageService.getPendoUserId();
      const hospid = this.storageService.getUserHospitalId();
      const hospname = this.storageService.getUserHospitalName();
      if (hospname && (hospname.length > 0) && (w)) {
        if ((w.pendo) && (w.pendo.getVisitorId)) {
          visitor = w.pendo.getVisitorId();
          w.pendo.updateOptions({
                account: {
                  id: hospid,
                  accountName: hospname
                }
          });
          this.logger.info('pendo.service', 'updatePendo',this.subscriptionService.SelectedSubscription, this.subscriptionService.AvailableSubscriptionsString, `Window: ${w.name}, visitor:${visitor}, account:${hospname}`, '');
        } else {
          // this.logger.warning(this.user, 'Wrap PendoService updatePendo', `visitor:${visitor}, account:${hospname} - Pendo is being blocked by this hospital`);
        }
      }
    }
}
